"use client";

import { type ReactNode } from "react";
import posthog from "posthog-js";
import { type RetailReferral } from "@/config/retail-referrals";

type Props = Pick<RetailReferral, "href" | "sourcePath" | "productSlug" | "placement"> & {
	children: ReactNode;
};

export function RetailReferralLink({ href, sourcePath, productSlug, placement, children }: Props) {
	function trackClick() {
		try {
			if (!posthog.__loaded || posthog.has_opted_out_capturing()) return;
			posthog.capture(
				"retail_referral_clicked",
				{
					locale: "de",
					placement,
					source_path: sourcePath,
					product_slug: productSlug,
					target_url: href,
				},
				{ transport: "sendBeacon" },
			);
		} catch {
			// Analytics must never prevent ordinary link navigation.
		}
	}

	return (
		<a
			href={href}
			onClick={trackClick}
			className="decoration-primary/40 rounded-sm text-primary underline underline-offset-4 hover:decoration-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
		>
			{children}
		</a>
	);
}
